

// const DeleteAccount = () => {


//   return (

//   );
// };

// export default DeleteAccount;
import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, deleteUser } from 'firebase/auth';
import { CircularProgress } from '@mui/material';
import { color } from '@mui/system';
import { getFirestore, doc, deleteDoc } from 'firebase/firestore';
import app from '../firebase.config';

function Deleteacc() {
    const auth = getAuth();
    const [email, setEmail] = useState('');
    const [loading,setLoading]=useState(false)
    const [password, setPassword] = useState('');
    const [deletionError, setDeletionError] = useState(null);
    const [isDeleted, setIsDeleted] = useState(false);
  
    const handleSignInAndDelete = async () => {
        setLoading(true)
      try {
        // Sign in the user first
        await signInWithEmailAndPassword(auth, email, password);
  
        // Delete the user's account
        const user = auth.currentUser;
        const uid = user.uid;
        const firestore = getFirestore(app);

        const userDocRef = doc(firestore, 'users', uid); 
        await deleteDoc(userDocRef);   
        await deleteUser(auth.currentUser);
        setIsDeleted(true);
        console.log("sone");
        setLoading(false);
        setDeletionError("done");

       alert("Successfully Deleted User Account");
       setEmail("");
       setPassword("");

      } catch (error) {
        setDeletionError(error.message);
        setIsDeleted(false);
        console.log(error);
        setLoading(false);
      }
    };
  return (

        <div style={{height:window.innerHeight,display:'flex',flexDirection:"column",width:"100%",justifyContent:"center",alignItems:"center"}}>
     
          
          <p style={{color:"black",fontSize:"20px"}}>Enter your email and password to delete your account:</p>
          <input
            style={{marginTop:"20px"}}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            style={{marginTop:"20px"}}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
{      loading?<CircularProgress style={{color:'black',marginTop:"20px"}}/>:<button style={{marginTop:"20px",borderRadius:"5px"}} onClick={handleSignInAndDelete}>Delete Account</button>
}          {deletionError && <p> {deletionError.substring(10)}</p>}
      
   
    </div>
  )
}

export default Deleteacc